/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class SalvarFiltro {
    public static inicializar() {
      var salvarFiltro = new App.SalvarFiltro();
      salvarFiltro.inicializarEventos();
    }
  }
}

namespace App {
  export class SalvarFiltro {
    private ajax: IAjax;
    private static elModalSalvarFiltrosJogadores: JQuery = $("#modalSalvarFiltrosJogadores");
    private static contexto: any;
    private elCampoNomeFiltro: JQuery = $("input[name=nome_filtro]");
    private elCheckboxSalvarValorOferta: JQuery = $("input[name=salvar_valor_oferta]");
    private elBtnSalvarFiltroModal: JQuery = $("#btnSalvarFiltroModal");
    private elAplicarFiltroModal: JQuery = $(".aplicar-filtro");
    private elBotaoLimparFiltro: JQuery = $("#limparFiltro, .limpar-filtro");
    public inicializarEventos(contexto: any = null) {
      this.ajax = new App.Ajax();
      var modelView = new ModelView();
      modelView.pedirConfirmacaoExclusao = false;
      modelView.inicializar(null, false, App.SalvarFiltro.acaoAposExclusao);

      if (contexto) {
        App.SalvarFiltro.contexto = contexto;
      } else {
        App.SalvarFiltro.contexto = App.Sniper.contexto;
      }

      this.elBtnSalvarFiltroModal.on('click', (e) => { this.aoSalvarFiltro(e); });
      this.elAplicarFiltroModal.on('click', (e) => { App.SalvarFiltro.aoAplicarFiltro(e); });
      this.elBotaoLimparFiltro.on('click', (e) => { this.aoLimparFiltro(e) });
    }

    public static acaoAposExclusao(dados: IRespostaSucessoAjx) {
      let e: JQueryEventObject = dados.parametroCallback;
      $(e.currentTarget).parents('tr').remove();
    }

    private getFiltrosAtuais(): IFiltro {
      var dadosForm: any = this.ajax.convertFormToJSON(App.SalvarFiltro.contexto.elFormCompra);
      var filtro: IFiltro = {
        start: 0,
        num: 21,
        maxb: dadosForm.hasOwnProperty("max") && App.Util.ehVariavelValidaNaoVazia(dadosForm.max) ? dadosForm.max : 200,
        micr: App.SalvarFiltro.contexto.valorMinimo,
        type: "player"
      }

      if (dadosForm.hasOwnProperty("min") && dadosForm.min) {
        filtro.minb = dadosForm.min;
      }
      if (dadosForm.hasOwnProperty("liga") && dadosForm.liga) {
        filtro.leag = dadosForm.liga;
      }
      if (dadosForm.hasOwnProperty("time") && dadosForm.time) {
        filtro.team = dadosForm.time;
      }

      if (dadosForm.hasOwnProperty("jogador") && dadosForm.jogador.length > 0) {
        if (App.SalvarFiltro.contexto.ehJogadorEspecial) {
          filtro.definitionId = dadosForm.jogador;
        } else {
          filtro.maskedDefId = dadosForm.jogador;
        }
      }

      if (dadosForm.hasOwnProperty("pais") && dadosForm.pais) {
        filtro.nat = dadosForm.pais;
      }
      if (dadosForm.hasOwnProperty("estilo") && dadosForm.estilo) {
        filtro.playStyle = dadosForm.estilo;
      }
      if (dadosForm.hasOwnProperty("estilo_jogo") && dadosForm.estilo_jogo) {
        filtro.icontraits = dadosForm.estilo_jogo;
      }
      if (dadosForm.hasOwnProperty("qualidade") && dadosForm.qualidade) {
        if (dadosForm.qualidade == 'SP') {
          filtro.rare = dadosForm.qualidade;
        } else {
          filtro.lev = dadosForm.qualidade;
        }
      }

      if (dadosForm.hasOwnProperty('posicao') && dadosForm.posicao) {
        if (dadosForm.posicao == 'defense' || dadosForm.posicao == 'midfield' || dadosForm.posicao == 'attacker') {
          filtro.zone = dadosForm.posicao;
        } else {
          filtro.pos = dadosForm.posicao;
        }
      }

      if (dadosForm.hasOwnProperty("carta_rara") && dadosForm.carta_rara) {
        filtro.rare = 1;
      }

      if (dadosForm.hasOwnProperty("raridade") && dadosForm.raridade) {
        filtro.rarityIds = dadosForm.raridade;
      }

      filtro.quantidadesMaxCompras = parseInt($("input[name='quantidadesMaxCompras']").val());
      filtro.velocidadeTentativas = parseInt($("select[name='milesegundos']").val());
      filtro.quantidadesMaxTentativas = parseInt($("input[name='quantidadesMaxTentativas']").val());
      filtro.tempoDeIntervalo = parseInt($("input[name='programarIntervalo']").val());
      filtro.tempoProgramado = parseInt($("select[name='programarCompra']").val());
      filtro.tipoFiltro = App.SalvarFiltro.contexto.ehJogadorEspecial ? 2 : 1;

      filtro.precoCompra = parseInt(dadosForm.precoCompra)
      if (filtro.precoCompra == 2) {
        filtro.lucroVariarAbaixo = parseInt($("input[name='lucro_variar_abaixo']").val())
        filtro.lucro = parseInt($("input[name='lucro']").val())
        filtro.lucroVariarAcima= parseInt($("input[name='lucro_variar_acima']").val())
      }

      filtro.ativarVendaAutomatica = dadosForm.ativar_venda_automatica ? true : false;
      if (filtro.ativarVendaAutomatica) {
        let valorLanceMinimo: any = App.Util.obterInteiroDaString($("input[name='valor_lance_minimo']").val())
        let valorVenda: any = App.Util.obterInteiroDaString($("input[name='valor_venda']").val())
        filtro.valorLanceMinimo = !App.Util.empty(valorLanceMinimo) ? parseInt(valorLanceMinimo) : null
        filtro.valorVenda = !App.Util.empty(valorVenda) ? parseInt(valorVenda) : null
        filtro.precoFutbin = $("#ativarPrecoVendaFutbin").is(':checked') ? true : false
        filtro.porcentagemVendaMaisBarato = dadosForm.porcentagem_venda_mais_barato && $.isNumeric(dadosForm.porcentagem_venda_mais_barato) ? parseInt(dadosForm.porcentagem_venda_mais_barato) : 0
        filtro.precoInteligente = $("#ativarPrecoVendaInteligente").is(':checked') ? App.Util.obterInteiroDaString($("#inputSlidePrecoInteligente").val()) : null
      }

      console.log("dadosForm", dadosForm, filtro)

      return filtro;
    }

    private aoSalvarFiltro(e: JQueryEventObject) {
      var dados: any = { nome: this.elCampoNomeFiltro.val(), salvar_valor_oferta: true, dados: this.getFiltrosAtuais() };
      this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("urlSalvarFiltro"), dados, App.SalvarFiltro.acaoAposSalvarFiltro);
    }

    private static aoAplicarFiltro(e: JQueryEventObject) {
      var filtro: any = $(e.currentTarget).data('filtro');
      var aplicarValorOferta: any = $(e.currentTarget).data('aplicarValorOferta');

      if (filtro.hasOwnProperty("minb") && filtro.minb) {
        $("input[name=min]").val(filtro.minb).trigger('input').trigger('change');
      } else {
        $("input[name=min]").val('').trigger('input').trigger('change');
      }

      if (aplicarValorOferta) {
        $("input[name=max]").val(filtro.maxb).trigger('input').trigger('change');
      } else {
        $("input[name=max]").val('200').trigger('input').trigger('change');
      }

      if (filtro.hasOwnProperty("lev") && filtro.lev) {
        $('#qualidade').val(filtro.lev).trigger('change').trigger('select2:select');
      } else if (filtro.hasOwnProperty("rare") && filtro.rare && !$.isNumeric(filtro.rare)) {
        $('#qualidade').val(filtro.rare).trigger('change').trigger('select2:select');
      } else {
        $('#qualidade').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("rare") && $.isNumeric(filtro.rare) && filtro.rare) {
        $('#cartaRara').prop("checked", true);
      } else {
        $('#cartaRara').prop("checked", false);
      }

      if (filtro.hasOwnProperty("pos") && filtro.pos) {
        $('#posicao').val(filtro.pos).trigger('change').trigger('select2:select');
      } else if (filtro.hasOwnProperty("zone") && filtro.zone) {
        $('#posicao').val(filtro.zone).trigger('change').trigger('select2:select');
      } else {
        $('#posicao').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("playStyle") && filtro.playStyle) {
        $('#estilo').val(filtro.playStyle).trigger('change').trigger('select2:select');
      } else {
        $('#estilo').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("nat") && filtro.nat) {
        $('#pais').val(filtro.nat).trigger('change').trigger('select2:select');
      } else {
        $('#pais').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("leag") && filtro.leag) {
        $('#liga').val(filtro.leag).trigger('change').trigger('select2:select');
      } else {
        $('#liga').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("team") && filtro.team) {
        $('#time').val(filtro.team).trigger('change').trigger('select2:select');
      } else {
        $('#time').val('').trigger('change').trigger('select2:select');
      }
      if (filtro.hasOwnProperty("rarityIds") && filtro.rarityIds) {
        $('#raridade').val(filtro.rarityIds).trigger('change').trigger('select2:select');
      } else {
        $('#raridade').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("icontraits") && filtro.icontraits) {
        $('#estiloJogo').val(filtro.icontraits).trigger('change').trigger('select2:select');
      } else {
        $('#estiloJogo').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("precoCompra") && $.isNumeric(filtro.precoCompra)) {
        $("input[name=precoCompra][value=" + `${filtro.precoCompra}` + "]").prop("checked", true).trigger('input').trigger('change');
        $("input[name='lucro_variar_abaixo']").val(filtro.lucroVariarAbaixo ? filtro.lucroVariarAbaixo : 0)
        $("input[name='lucro']").val(filtro.lucro ? filtro.lucro : 50)
        $("input[name='lucro_variar_acima']").val(filtro.lucroVariarAcima ? filtro.lucroVariarAcima : 0)

        if (filtro.precoCompra == 1) {
          $("#alertAplicarFiltro").show()
          setTimeout(() => {
            $("#alertAplicarFiltro").hide()
          }, 60000);
        } else {
          $("#alertAplicarFiltro").hide()
        }
      }

      if (filtro.hasOwnProperty("maskedDefId") && filtro.maskedDefId.length > 1) {
        $("#searchclear").click();
        $.each(filtro.maskedDefId, function (index: any, value: string | number) {
          var player = App.Util.getItemArrayById(App.SalvarFiltro.contexto.players, parseInt(value.toString()));
          var option = new Option(JSON.stringify(player), player.id, true, true);
          option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
          $("#jogador").append(option).trigger('change').trigger('select2:select');
        });
      } else if (filtro.hasOwnProperty("maskedDefId")) {
        var player = App.Util.getItemArrayById(App.SalvarFiltro.contexto.players, parseInt($.isArray(filtro.maskedDefId) ? filtro.maskedDefId[0] : filtro.maskedDefId));
        var option = new Option(JSON.stringify(player), player.id, true, true);
        option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
        $("#searchclear").click();
        $("#jogador").append(option).trigger('change').trigger('select2:select');
      } else if (filtro.hasOwnProperty("definitionId") && filtro.definitionId.length > 1) {
        $("#searchclear").click();
        $.each(filtro.definitionId, function (index: any, value: string | number) {
          $.get(App.Util.config.urlJogadorEspecial.replace("?", value.toString()), function (data: any) {
            var option = new Option(JSON.stringify(data), data.id, true, true);
            option.title = data.name;
            $("#jogador").append(option).trigger('change').trigger('select2:select');
          });
        });

      } else if (filtro.hasOwnProperty("definitionId")) {
        $.get(App.Util.config.urlJogadorEspecial.replace("?", filtro.definitionId.toString()), function (data: any) {
          var option = new Option(JSON.stringify(data), data.id, true, true);
          option.title = data.name;
          $("#searchclear").click();
          $("#jogador").append(option).trigger('change').trigger('select2:select');
        });
      } else {
        $("#searchclear").click();
      }
      if (filtro.hasOwnProperty("quantidadesMaxCompras")) {
        $("input[name='quantidadesMaxCompras']").val(filtro.quantidadesMaxCompras);
        $('.info-limite-compra').html(filtro.quantidadesMaxCompras);
      }
      if (!App.SalvarFiltro.contexto.ehLance && filtro.hasOwnProperty("velocidadeTentativas")) {
        // App.SalvarFiltro.contexto.elCampoNoUiSliderVelocidade.noUiSlider.set(filtro.velocidadeTentativas);
        App.SalvarFiltro.contexto.objSelect2.setSelectTag(App.SalvarFiltro.contexto.selectVelocidade, { id: filtro.velocidadeTentativas ? filtro.velocidadeTentativas.toString() : '4000', text: `${filtro.velocidadeTentativas ? filtro.velocidadeTentativas.toString() : '4000'} ${App.SalvarFiltro.contexto.selectVelocidade.data('sufixDesc')}` })
      }
      if (!App.SalvarFiltro.contexto.ehLance && filtro.hasOwnProperty("quantidadesMaxTentativas")) {
        App.SalvarFiltro.contexto.elCampoNoUiSliderTentativas.noUiSlider.set(filtro.quantidadesMaxTentativas);
      }
      if (filtro.hasOwnProperty("tempoDeIntervalo")) {
        App.SalvarFiltro.contexto.elCampoNoUiSliderIntervaloDescanso.noUiSlider.set(filtro.tempoDeIntervalo);
      }
      if (filtro.hasOwnProperty("tempoProgramado")) {
        // App.SalvarFiltro.contexto.elCampoNoUiSliderProgramarCompra.noUiSlider.set(filtro.tempoProgramado);
        App.SalvarFiltro.contexto.objSelect2.setSelectTag(App.SalvarFiltro.contexto.selectProgramarCompra, { id: filtro.tempoProgramado ? filtro.tempoProgramado.toString() : '30', text: `${filtro.tempoProgramado ? filtro.tempoProgramado.toString() : '30'} ${App.SalvarFiltro.contexto.selectProgramarCompra.data('sufixDesc')}` })
      }

      if (filtro.hasOwnProperty("ativarVendaAutomatica")) {
        $('input[name=ativar_venda_automatica]').prop('checked', filtro.ativarVendaAutomatica).trigger('change');
        if (filtro.ativarVendaAutomatica) {
          $("#ativarPrecoVendaFutbin").prop('checked', filtro.precoFutbin).trigger('change');
          if (filtro.precoFutbin) {
            App.SalvarFiltro.contexto.elCampoNoUiSliderPorcentagemVendaMaisBarato.noUiSlider.set(filtro.porcentagemVendaMaisBarato);
          }
          $("#ativarPrecoVendaInteligente").prop('checked', (filtro.precoInteligente ? true : false)).trigger('change');
          $("input[name='valor_lance_minimo']").val(filtro.valorLanceMinimo).trigger('input').trigger('change');
          $("input[name='valor_venda']").val(filtro.valorVenda).trigger('input').trigger('change');
        }
      }

      $('#modalFiltroSalvosJogadores').modal('hide');
    }

    public static aplicarFiltroExterno(filtro: any) {
      if (filtro.hasOwnProperty("minb") && filtro.minb) {
        $("input[name=min]").val(filtro.minb).trigger('input').trigger('change');
      } else {
        $("input[name=min]").val('').trigger('input').trigger('change');
      }

      if (filtro.hasOwnProperty("maxb") && filtro.maxb) {
        $("input[name=max]").val(filtro.maxb).trigger('input').trigger('change');
      } else {
        $("input[name=max]").val(200).trigger('input').trigger('change');
      }

      if (filtro.hasOwnProperty("lev") && filtro.lev) {
        $('#qualidade').val(filtro.lev).trigger('change').trigger('select2:select');
      } else if (filtro.hasOwnProperty("rare") && filtro.rare && !$.isNumeric(filtro.rare)) {
        $('#qualidade').val(filtro.rare).trigger('change').trigger('select2:select');
      } else {
        $('#qualidade').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("rare") && $.isNumeric(filtro.rare) && filtro.rare) {
        $('#cartaRara').prop("checked", true);
      } else {
        $('#cartaRara').prop("checked", false);
      }

      if (filtro.hasOwnProperty("pos") && filtro.pos) {
        $('#posicao').val(filtro.pos).trigger('change').trigger('select2:select');
      } else if (filtro.hasOwnProperty("zone") && filtro.zone) {
        $('#posicao').val(filtro.zone).trigger('change').trigger('select2:select');
      } else {
        $('#posicao').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("playStyle") && filtro.playStyle) {
        $('#estilo').val(filtro.playStyle).trigger('change').trigger('select2:select');
      } else {
        $('#estilo').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("nat") && filtro.nat) {
        $('#pais').val(filtro.nat).trigger('change').trigger('select2:select');
      } else {
        $('#pais').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("leag") && filtro.leag) {
        $('#liga').val(filtro.leag).trigger('change').trigger('select2:select');
      } else {
        $('#liga').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("team") && filtro.team) {
        $('#time').val(filtro.team).trigger('change').trigger('select2:select');
      } else {
        $('#time').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("rarityIds") && filtro.rarityIds) {
        $('#raridade').val(filtro.rarityIds).trigger('change').trigger('select2:select');
      } else {
        $('#raridade').val('').trigger('change').trigger('select2:select');
      }

      if (filtro.hasOwnProperty("icontraits") && filtro.icontraits) {
        $('#estiloJogo').val(filtro.icontraits).trigger('change').trigger('select2:select');
      } else {
        $('#estiloJogo').val('').trigger('change').trigger('select2:select');
      }



      if (filtro.hasOwnProperty("maskedDefId") && filtro.maskedDefId.length > 1) {
        $("#searchclear").click();
        $.each(filtro.maskedDefId, function (index: any, value: string | number) {
          var player = App.Util.getItemArrayById(App.SalvarFiltro.contexto.players, parseInt(value.toString()));
          var option = new Option(JSON.stringify(player), player.id, true, true);
          option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
          $("#jogador").append(option).trigger('change').trigger('select2:select');
        });
      } else if (filtro.hasOwnProperty("maskedDefId")) {
        var player = App.Util.getItemArrayById(App.SalvarFiltro.contexto.players, parseInt($.isArray(filtro.maskedDefId) ? filtro.maskedDefId[0] : filtro.maskedDefId));
        var option = new Option(JSON.stringify(player), player.id, true, true);
        option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
        $("#searchclear").click();
        $("#jogador").append(option).trigger('change').trigger('select2:select');
      } else if (filtro.hasOwnProperty("definitionId") && filtro.definitionId.length > 1) {
        $("#searchclear").click();
        $.each(filtro.definitionId, function (index: any, value: string | number) {
          $.get(App.Util.config.urlJogadorEspecial.replace("?", value.toString()), function (data: any) {
            var option = new Option(JSON.stringify(data), data.id, true, true);
            option.title = data.name;
            $("#jogador").append(option).trigger('change').trigger('select2:select');
          });
        });

      } else if (filtro.hasOwnProperty("definitionId")) {
        $.get(App.Util.config.urlJogadorEspecial.replace("?", filtro.definitionId.toString()), function (data: any) {
          var option = new Option(JSON.stringify(data), data.id, true, true);
          option.title = data.name;
          $("#searchclear").click();
          $("#jogador").append(option).trigger('change').trigger('select2:select');
        });
      } else {
        $("#searchclear").click();
      }
    }

    public static acaoAposSalvarFiltro(dados: IRespostaSucessoAjx) {
      App.SalvarFiltro.elModalSalvarFiltrosJogadores.modal('hide');
      if (dados.dadosRetornados.dadosResposta == null) {
        return;
      }
      var urlExcluirFiltro = $('#tabelaFiltrosSalvos').data('urlExcluir');
      var seletorExcluirFiltro = 'excluir-filtro-' + dados.dadosRetornados.dadosResposta.id;
      var seletorAplicarFiltro = 'aplicar-filtro-' + dados.dadosRetornados.dadosResposta.id;

      var linhaTabela = $('#id' + dados.dadosRetornados.dadosResposta.id);
      if (linhaTabela.length > 0) {
        $(linhaTabela).remove();
      }

      $('#tabelaFiltrosSalvos tr:first').after('<tr id="id' + dados.dadosRetornados.dadosResposta.id + '"><td>' + dados.dadosRetornados.dadosResposta.nome + (dados.dadosRetornados.dadosResposta.salvar_valor_oferta ? '<span class="badge badge-warning" style="color: #b6a802;background-color: rgba(255, 247, 154, 0.5);">Com valor de oferta</span>' : '') + '</td><td class="opcoes-filtro"><span data-id="' + dados.dadosRetornados.dadosResposta.id + '" data-url="' + urlExcluirFiltro + '" class="pull-right cursor-pointer text-danger ' + seletorExcluirFiltro + '"><i title="Excluir filtro" class="fa fa-trash-o"></i></span><span data-aplicar-valor-oferta=' + dados.dadosRetornados.dadosResposta.salvar_valor_oferta + ' data-filtro=' + JSON.stringify(dados.dadosEnviados.dados) + ' class="pull-right cursor-pointer text-success ' + seletorAplicarFiltro + '"><i title="Aplicar filtro" class="fa fa-check"></i>&nbsp;&nbsp;&nbsp;</span></td></tr>');
      var modelView = new ModelView();
      modelView.pedirConfirmacaoExclusao = false;
      modelView.inicializarBotaoExcluir($('.' + seletorExcluirFiltro))
      $('.' + seletorAplicarFiltro).on('click', (e) => { App.SalvarFiltro.aoAplicarFiltro(e); });

    }
    private aoLimparFiltro(e: JQueryEventObject) {
      $("#searchclear").click();
      $("input[name=max]").val('200').trigger('input').trigger('change');
      $('#qualidade').val('').trigger('change').trigger('select2:select');
      $('#raridade').val('').trigger('change').trigger('select2:select');
      $('#posicao').val('').trigger('change').trigger('select2:select');
      $('#estilo').val('').trigger('change').trigger('select2:select');
      $('#estiloJogo').val('').trigger('change').trigger('select2:select');
      $('#pais').val('').trigger('change').trigger('select2:select');
      $('#liga').val('').trigger('change').trigger('select2:select');
      $('#time').val('').trigger('change').trigger('select2:select');
      $('#cartaRara').prop("checked", false);
    }
  }
}
